module.exports = __webpack_public_path__ + "img/passion.fe4765fd.svg";